/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NonConformanceItem } from '../../models/non-conformance-item';

export interface GetNonConformanceOverview$Params {
  workCenterId: number;
  articleId: number;
}

export function getNonConformanceOverview(http: HttpClient, rootUrl: string, params: GetNonConformanceOverview$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NonConformanceItem>>> {
  const rb = new RequestBuilder(rootUrl, getNonConformanceOverview.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('articleId', params.articleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NonConformanceItem>>;
    })
  );
}

getNonConformanceOverview.PATH = '/api/v1/QualityHistory/{workCenterId}/GetNonConformanceOverview/{articleId}';
